import { defineStore } from 'pinia';
import { Subject, filter } from 'rxjs';
import { computed } from 'vue';

export const useKeyboardEventStore = defineStore('keyboardEvent', () => {
  const keyboardEventTrigger = new Subject<KeyboardEvent>();

  const events = computed(() => keyboardEventTrigger.asObservable());

  const listenForKey = (key: string) => {
    return events.value.pipe(filter((ev) => ev.key === key));
  };

  return {
    events,
    keyboardEventTrigger,
    listenForKey,
  };
});
